import { render, staticRenderFns } from "./MStoreDocumentTypeSelect.vue?vue&type=template&id=2b3fabb1&"
import script from "./MStoreDocumentTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./MStoreDocumentTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports